import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { environment } from '../../../../environments/environment'
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { CustomToastrService } from '../../../Shared/Services/custom-toastr.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ContractsWarrantiesService } from '../../../Services/contracts-warranties.service';
import { Router } from '@angular/router';
import { DialogService } from '../../../Shared/Services/dialog.service';
import { LoginVm } from '../../../Model/LoginVM';
import { AuthService } from '../../../Shared/Services/auth.service';
import { SharedService } from '../../../Shared/Services/shared.service';

@Component({
  selector: 'app-contract-before-save',
  templateUrl: './contract-before-save.component.html',
  styleUrl: './contract-before-save.component.scss'
})
export class ContractBeforeSaveComponent {
  private destroy$: Subject<boolean> = new Subject<boolean>();
  formErrors: string[] = [];
  arr: any[] = [];
  dataRes?: any;
  imgPath: string = environment.ImgUrl;
  DataNow: Date = new Date();
  PaymentValues: number[] = [];
  ContractNumber: number = 0;
  currentUser?: LoginVm;
  fromPrice?: boolean = false;

  constructor(private api: ContractsWarrantiesService, private dialogRef: MatDialogRef<ContractBeforeSaveComponent>,
    private auth: AuthService, private toastrService: CustomToastrService, private spinner: NgxSpinnerService, private shared: SharedService,
    @Inject(MAT_DIALOG_DATA) public data: ContractBeforeSaveComponent, private router: Router, private dialogService: DialogService) {
    this.dataRes = data;
    this.dataRes.TotalCost = 0;
    this.fromPrice = data.fromPrice;
    this.ClacTotalCostForAll();
    this.GetCurrentUser();
    this.CalcPaymentValues();
    this.GetContractNumber();
  }

  ngOnInit() {
    for (let i = 1; i <= this.dataRes.PaymentsNumber; i++) {
      this.arr.push(this.counter(i));
    }
  }

  GetCurrentUser() {
    let jsonObj = this.auth.getStorage("currentUser");
    this.currentUser = <LoginVm>JSON.parse(jsonObj);
  }

  GetContractNumber() {
    this.api.GetContractNumber()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data: any) => {
          if (data.isSuccess) {
            this.ContractNumber = data.payload;
          }
        },
        error: (error: any) => {
          this.toastrService.showErrorToast('Error', "SomethingWentWrong");
        }
      });
  }

  CalcPaymentValues() {
    let TotalCost = this.dataRes.TotalCost;
    for (let i = 0; i < this.dataRes.PercentagePayment.length; i++) {
      let value = TotalCost * this.dataRes.PercentagePayment[i];
      this.PaymentValues.push(value)
    }
  }

  ClacTotalCostForAll() {
    for (let i = 0; i < this.dataRes.CostCalc.length; i++) {
      let count = this.dataRes.CostCalc[i].count ?? 1;
      this.dataRes.TotalCost += this.dataRes.CostCalc[i].totalPrice * count;
    }
  }

  counter(i: number) {
    return new Array(i);
  }

  ClacTotalCost(totalPrice?: number, count?: number) {
    return this.shared.ClacTotalCost(totalPrice, count);
  }

  ClacArea(width?: any, height?: any): number {
    return (width ?? 1) * (height ?? 1);
  }

  onClose(): void {
    this.dialogService.confirmDialog({
      titleKey: 'confirmation',
      messageKey: 'AreYouSuretoBackWithoutSave',
      confirmTextKey: 'Yes',
      cancelTextKey: 'No'
    }).subscribe(isConfirmed => {
      if (isConfirmed) {
        this.dialogRef.close();
      }
    });
  }

  SaveContractWithClient() {
    this.dialogService.confirmDialog({
      titleKey: 'confirmation',
      messageKey: 'AreYouSuretoSaveThis',
      confirmTextKey: 'Yes',
      cancelTextKey: 'No'
    }).subscribe(isConfirmed => {
      if (isConfirmed) {
        this.ConfirmSaveContractWithClient();
      }
    });
  }

  ConfirmSaveContractWithClient() {
    this.spinner.show();
    let numberOfCostCalc: string = '';
    let InstallationDate: string = '';
    for (let i = 0; i < this.dataRes.CostCalc.length; i++) {
      numberOfCostCalc += this.dataRes.CostCalc[i].id + ","
      InstallationDate += this.dataRes.CostCalc[i].InstallationDate + ","
    }

    numberOfCostCalc = numberOfCostCalc.substring(numberOfCostCalc.length - 1, 1);
    InstallationDate = InstallationDate.substring(InstallationDate.length - 1, 1);

    const form = {
      contractData: {
        clientId: this.dataRes.Client.id,
        totalInvoices: this.dataRes.TotalCost,
        numberOfCostCalc: numberOfCostCalc,
        invoicesNumber: this.ContractNumber,
        installationDates: InstallationDate,
      },
      installmentsPercentages: this.dataRes.PercentagePayment
    };

    this.api.CreateContract(form).pipe(takeUntil(this.destroy$))
      .subscribe(
        {
          next: (data: any) => {
            this.spinner.hide();
            this.toastrService.showSuccessToast('Success', 'contractSavedSuccessfully');
            this.dialogRef.close();
            if (this.fromPrice) {
              this.router.navigateByUrl('dashboard/price-offers');
            }
            else {
              this.router.navigateByUrl('dashboard/contracts-warranties');
            }
          },
          error: (error: any) => {
            this.spinner.hide();
            this.toastrService.showErrorToast('Error', "SomethingWentWrong");
          }
        });
  }
}
